import React, { useState, useEffect } from 'react';

function CariRute({ onSelect, onCancel, kd_rekanan }) {
  const [ruteList, setRuteList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');  
  const [filteredRute, setFilteredRute] = useState([]);  
  const schema = localStorage.getItem('schema');

  useEffect(() => {
    const fetchRute = async () => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=rute&schema=${schema}&kd_rekanan=${kd_rekanan}`;
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }        
        const data = await response.json();
        setRuteList(data);
        setFilteredRute(data);
      } catch (error) {
        console.error('Error fetching rute:', error);
      }
    };

    if (kd_rekanan) {
      fetchRute();
    }
  }, [kd_rekanan]);

  useEffect(() => {
    const filtered = ruteList.filter((rute) =>
      rute.KOTA_ASAL.toLowerCase().includes(searchTerm.toLowerCase()) || 
      rute.KOTA_TUJUAN.toLowerCase().includes(searchTerm.toLowerCase()) ||
      rute.SUBCITY.toLowerCase().includes(searchTerm.toLowerCase()) ||
      rute.JNS_KENDARAAN.toLowerCase().includes(searchTerm.toLowerCase()) ||
      rute.JNS_MUATAN.toLowerCase().includes(searchTerm.toLowerCase()) 
    );
    setFilteredRute(filtered);
  }, [searchTerm, ruteList]);

  return (
    <div
      style={{
        width: '500px',
        margin: 'auto',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
      }}
    >
      <h2>Cari Rute</h2>

      <div style={{ marginBottom: '10px' }}>
        <label>Cari Kota:</label>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Masukkan asal atau tujuan"
          style={{
            width: '100%',
            padding: '5px',
            marginBottom: '10px',
            borderRadius: '5px',
            border: '1px solid #ccc',
          }}
        />
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '10px' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Asal</th>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Tujuan</th>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Subcity</th>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Jns Kend</th>
            <th style={{ border: '1px solid #ddd', padding: '8px' }}>Jns Muatan</th>           
            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {filteredRute.map((rute, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #ddd', padding: '5px' }}>{rute.KOTA_ASAL}</td>
              <td style={{ border: '1px solid #ddd', padding: '5px' }}>{rute.KOTA_TUJUAN}</td>
              <td style={{ border: '1px solid #ddd', padding: '5px' }}>{rute.SUBCITY}</td>
              <td style={{ border: '1px solid #ddd', padding: '5px' }}>{rute.JNS_KENDARAAN}</td>
              <td style={{ border: '1px solid #ddd', padding: '5px' }}>{rute.JNS_MUATAN}</td>             
              <td style={{ textAlign: 'center', border: '1px solid #ddd', padding: '5px' }}>
                <button
                  onClick={() => onSelect(rute)}
                  style={{
                    padding: '5px 10px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Pilih
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ textAlign: 'center' }}>
        <button
          onClick={onCancel}
          style={{
            padding: '10px 15px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Batal
        </button>
      </div>
    </div>
  );
}

export default CariRute;
